<!-- 汇率维护 -->
<template>
  <div class="interestBankAdd">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button @click="save()" type="primary" class="vxe-btn-primary">{{
          $t('interestBank.button.save')
        }}</vxe-button>
        <vxe-button
          @click="insertEvent()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('interestBank.button.add') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('interestBank.button.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
    </vxe-grid>
  </div>
</template>

<script>
  import { addRules } from './rules.js'; // 校验规则
  import API from '@/api/capitalCenter/moneyDraw';
  // import InputNumber from '@/components/form-item/input-number';
  export default {
    name: 'interestBankAdd',
    components: {
      // InputNumber,
    },
    computed: {
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            // 公司
            field: 'companyCode',
            title: this.$t('interestBank.column.company'),
            width: '180',
            editRender: {
              name: 'ElSelect',
              options: this.companyList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.companyChange },
            },
          },
          {
            // 合同号
            field: 'contractNo',
            title: this.$t('interestBank.column.contractNo'),
            width: '180',
            editRender: {
              name: 'ElInput',
            },
          },
          {
            // 借款日期
            field: 'loanDate',
            title: this.$t('interestBank.column.loanDate'),
            width: '180',
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            // 借款金额
            field: 'loanAmount',
            title: this.$t('interestBank.column.loanAmount'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.loanAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.loanAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'loanAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 还款日期
            field: 'refundDate',
            title: this.$t('interestBank.column.refundDate'),
            width: '180',
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            // 还款金额
            field: 'refundAmount',
            title: this.$t('interestBank.column.refundAmount'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.refundAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.refundAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'refundAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 天数
            field: 'loanDays',
            title: this.$t('interestBank.column.loanDays'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.loanDays}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.loanDays}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'loanDays')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 利率
            field: 'interestRate',
            title: this.$t('interestBank.column.interestRate'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestRate}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestRate}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'interestRate')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 利息
            field: 'interestAmount',
            title: this.$t('interestBank.column.interestAmount'),
            width: '150',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.interestAmount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.interestAmount}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'interestAmount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            // 币种
            field: 'currencyCode',
            title: this.$t('interestBank.column.currencyCode'),
            width: '150',
            editRender: {
              name: 'ElSelect',
              options: this.currencyList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            // 对应银行
            field: 'bankName',
            title: this.$t('interestBank.column.bankName'),
            width: '180',
            editRender: {
              name: 'ElSelect',
              options: this.bankList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            // 备注
            field: 'remark',
            title: this.$t('interestBank.column.remark'),
            width: '200',
            editRender: {
              name: 'ElInput',
            },
          },
        ];
      },
    },
    data() {
      return {
        companyList: [],
        currencyList: [],
        bankList: [],
        tableData: [], // 表格数据
        addRowObj: {
          companyCode: null,
          companyName: null,
          contractNo: null,
          loanDate: null,
          loanAmount: null,
          refundDate: null,
          refundAmount: null,
          loanDays: null,
          interestRate: null,
          interestAmount: null,
          currencyCode: null,
          bankName: null,
          remark: null,
        },
        rules: addRules, // 校验规则
      };
    },
    mounted() {
      this.resolveTableData(); // 初始五行表格空数据
      this.getCompany();
      this.getCurrency();
      this.getBankList();
    },
    methods: {
      chooseTable(val, row, prop) {
        row[prop] = val;
      },
      //公司代码
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      //币别
      async getCurrency() {
        let res = await this.$baseRequest.getCurrency();
        if (res) {
          this.currencyList = res;
          this.currencyList = this.currencyList.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      // 获取银行
      async getBankList() {
        let res = await this.$baseRequest.getMDBank();
        if (res) {
          this.bankList = res;
          this.bankList = this.bankList.map((item) => {
            return {
              value: item.bankCode,
              label: item.bankName,
            };
          });
        }
      },
      companyChange(val) {
        val.row.companyName = this.companyList.find(
          (item) => item.value == val.row.companyCode
        ).label;
      },
      // 表格新增一行
      insertEvent(row) {
        this.$refs.table.validate((valid) => {
          if (valid) {
            let record = {
              companyCode: null,
              companyName: null,
              contractNo: null,
              loanDate: null,
              loanAmount: null,
              refundDate: null,
              refundAmount: null,
              loanDays: null,
              interestRate: null,
              interestAmount: null,
              currencyCode: null,
              bankName: null,
              remark: null,
            };
            this.$refs.table.insertAt(record, row).then(({ row }) => {
              this.$refs.table.setActiveRow(row);
            });
          }
        });
      },
      // 表格删除
      handleDelete() {
        const selectedList = this.$refs.table.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('interestBank.msg.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.del.push(item.id);
              }
            });
            this.$refs.table.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('interestBank.msg.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('interestBank.msg.cancelled'),
            });
          });
      },
      async save() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        this.loading.startLoading();
        let res = await this.$axios.post(API.SAVE_INTERESTBANK, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.returnListPage();
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      // 初始五行表格空数据
      resolveTableData() {
        for (var i = 0; i < 1; i++) {
          this.tableData.push(JSON.parse(JSON.stringify(this.addRowObj)));
        }
      },
      // 返回列表页
      returnListPage() {
        let path = {
          fromPath: {
            path: '/moneyDraw/interestBankAdd',
            name: 'interestBankAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/moneyDraw/interestBankList',
            name: 'interestBankList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate((valid) => {
            if (valid) {
              tableData.map((item) => {
                item.isEnabled = item.isEnabled ? '1' : '0';
              });
              let param = {
                list: tableData,
              };
              resolve(param);
            }
          });
        });
      },
    },
  };
</script>

<style scoped></style>
